export const config = {
  title: 'Dust Busters Family Cleaning LLC | Zion, IL',
  meta: {
    description:
      'Family-owned and operated, Dust Busters Family Cleaning LLC offers high-quality, reliable, and safe home cleaning services in Zion, IL.',
    keywords: [
      'Dust Busters Family Cleaning',
      'Zion IL Cleaning Services',
      'Residential Cleaning',
      'Deep Cleaning',
      'Move-In Cleaning',
      'Move-Out Cleaning',
      'Post-Event Cleaning',
      'Eco-Friendly Cleaning',
      'Customized Cleaning Plans',
      'Specialty Surface Cleaning',
    ],
    author: 'Dust Busters Family Cleaning LLC',
    canonicalUrl: 'https://www.dustbustersfamilycleaning.com/',
  },
  sections: {
    header: {
      businessName: 'Dust Busters Family Cleaning LLC',
    },
    sectionB: {
      heroTitle: 'Experience a Glamorous Clean',
      heroSubtitle: 'Professional Home Cleaning Services in Zion, IL',
      learnAboutText: 'Discover Our Services',
      phoneNumber: '2247023556',
      phoneLabel: '(224) 702-3556',
      heroBackgroundImage:
        'https://media.istockphoto.com/id/1417833187/photo/professional-cleaner-vacuuming-a-carpet.jpg?s=612x612&w=0&k=20&c=5h8NBR190d46Ni4MclqJ7Zf9ZOtf3TM3gPRJaHUdMjk=',
      cardData: [
        {
          title: 'Residential Cleaning',
          description:
            'Maintain a spotless home with our regular cleaning services tailored to your needs.',
        },
        {
          title: 'Deep Cleaning',
          description:
            'Thorough cleaning solutions for every nook and cranny of your home.',
        },
        {
          title: 'Move-In/Move-Out Cleaning',
          description:
            'Ensure a fresh start or a clean farewell with our specialized cleaning services.',
        },
      ],
      description:
        'At Dust Busters Family Cleaning LLC, we pride ourselves on delivering exceptional cleaning services with a personal touch. Our eco-friendly solutions and flexible scheduling make us the preferred choice in Zion, IL.',
    },
    sectionC: {
      servicesTitle: 'Our Cleaning Services',
      servicesDescription:
        'Comprehensive cleaning solutions designed to meet your unique needs.',
      cards: [
        {
          title: 'Specialty Surface Cleaning',
          description:
            'Expert care for delicate and unique surfaces in your home.',
          imageSrc: 'https://media.istockphoto.com/id/2204307310/photo/cleaning-lady-wiping-wooden-table-with-blue-cloth-wearing-yellow-protective-gloves.jpg?s=612x612&w=0&k=20&c=xuXGot-MFWhPlxH7PNM-NKhkyii9qgMmfZczPtnPA5E=',
          imageAlt: 'Specialty Surface Cleaning',
        },
        {
          title: 'Customized Cleaning Plans',
          description:
            'Tailored cleaning schedules and services to fit your lifestyle.',
          imageSrc: 'https://media.istockphoto.com/id/1188462779/photo/cleaning-products-around-weekly-cleaning-plan-form-with-pen.jpg?s=612x612&w=0&k=20&c=mkbMQOJ4WtU2tijmbVMNXczwEyifpmOWPSLyoC9uK2U=',
          imageAlt: 'Customized Cleaning Plans',
        },
        {
          title: 'Post-Event Cleaning',
          description:
            'Efficient cleanup services to restore your space after any event.',
          imageSrc: 'https://media.istockphoto.com/id/1436521942/photo/three-janitors-performing-great-teamwork-with-disinfecting-chairs.jpg?s=612x612&w=0&k=20&c=Keh8G_Hh3TwiYyhBjef3Uzhz3zD526nJAi5fSdLrmJY=',
          imageAlt: 'Post-Event Cleaning',
        },
      ],
      otherServicesTitle: 'Additional Services',
      otherServicesList: [
        'Eco-Friendly Cleaning Solutions',
        'Flexible Scheduling',
        'Satisfaction Guaranteed',
        'Trusted Cleaning Professionals',
      ],
    },
    sectionD: {
      aboutTitle: 'About Us',
      aboutImage: {
        src: 'https://media.istockphoto.com/id/1417833124/photo/professional-cleaner-cleaning-a-table-at-a-house.jpg?s=612x612&w=0&k=20&c=WNc3TvhLIETMdAZTa4dALGvkZGXWaDHG9CihXID31F4=',
        alt: 'Dust Busters Family Cleaning Team',
      },
      aboutText: [
        'Dust Busters Family Cleaning LLC is a family-owned and operated business committed to providing high-quality, reliable, and safe cleaning solutions for your home.',
        'Our team of trusted professionals uses eco-friendly products to ensure a clean and healthy environment for you and your family.',
      ],
    },
    sectionE: {
      profileImage: null, // Add profile image URL if available
      profileAlt: 'Dust Busters Family Cleaning Logo',
      businessName: 'Dust Busters Family Cleaning LLC',
      contact: {
        phone: '2247023556',
        phoneLabel: '(224) 702-3556',
        email: 'dustbustersfamilycleaningllc@gmail.com',
        website: 'https://www.dustbustersfamilycleaning.com/',
        address: '2702 30th St, Zion, IL 60099, USA',
      },
      socialMedia: {
        facebook: null, // Add Facebook URL if available
        instagram: null, // Add Instagram URL if available
        twitter: null, // Add Twitter URL if available
        linkedIn: null, // Add LinkedIn URL if available
        youtube: null, // Add YouTube URL if available
      },
    },
    sectionF: {
      address: '2702 30th St, Zion, IL 60099, USA',
      googleMapsEmbedUrl:
        'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2968.123456789!2d-87.850123!3d42.446789!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x880f8f1234567890%3A0x123456789abcdef!2s2702%2030th%20St%2C%20Zion%2C%20IL%2060099%2C%20USA!5e0!3m2!1sen!2sus!4v1611234567890!5m2!1sen!2sus',
    },
  },
};

export default config;
